// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const dataTagName = (value: any, prefix = ''): string => {
  return value && typeof value === 'string'
    ? `${prefix}${value.replace(/ /g, '')}`
    : prefix
}
